import { Component, OnInit, OnDestroy } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { Subscription } from 'rxjs';

import { StateService } from '@services/Logic/state.service';

@Component({
  selector: 'app-done',
  animations: [
    trigger('doneAnimation', [
      transition(':enter', [
        style({ opacity: '0' }),
        animate('500ms', style({ opacity: '1' })),
      ]),
      transition(':leave', [
        style({ opacity: '1' }),
        animate('500ms', style({ opacity: '0' })),
      ]),
    ]),
  ],
  templateUrl: './done.component.html',
  styleUrls: ['./done.component.scss'],
})
export class DoneComponent implements OnInit, OnDestroy {
  isVisible: boolean;
  showDoneComponentRef: Subscription;

  constructor(private stateService: StateService) {
    this.isVisible = false;
  }

  ngOnInit() {
    this.showDoneComponentRef =
      this.stateService.showDoneComponentSource.subscribe((res) => {
        this.isVisible = res;
        this.hideComponent();
      });
  }

  ngOnDestroy() {
    this.showDoneComponentRef.unsubscribe();
  }

  hideComponent() {
    setTimeout(() => {
      this.isVisible = false;
    }, 2000);
  }
}
